import { api } from '@/lib/axios';
import type { AuthUser } from '@/store/authSlice';

export interface LoginPayload {
  email: string;
  password: string;
  mfaToken?: string;
}
export interface RegisterPayload {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export const authApi = {
  async login(payload: LoginPayload): Promise<{ user: AuthUser; accessToken: string }> {
    const { data } = await api.post('/auth/login', payload);
    return data.data;
  },
  async register(payload: RegisterPayload): Promise<{ user: AuthUser }> {
    const { data } = await api.post('/auth/register', payload);
    return data.data;
  },
  async me(): Promise<{ user: AuthUser }> {
    const { data } = await api.get('/auth/me');
    return data.data;
  },
  async refresh(): Promise<{ accessToken: string }> {
    const { data } = await api.post('/auth/refresh');
    return data.data;
  },
  async logout(): Promise<void> {
    await api.post('/auth/logout');
  },
  async forgotPassword(email: string): Promise<void> {
    await api.post('/auth/forgot-password', { email });
  },
  async resetPassword(token: string, password: string): Promise<void> {
    await api.post('/auth/reset-password', { token, password });
  },
  async verifyEmail(token: string): Promise<void> {
    await api.post('/auth/verify-email', { token });
  },
  async setupMfa(): Promise<{ secret: string; qrDataUrl: string; otpauthUrl: string }> {
    const { data } = await api.post('/auth/mfa/setup');
    return data.data;
  },
  async enableMfa(token: string): Promise<{ backupCodes: string[] }> {
    const { data } = await api.post('/auth/mfa/enable', { token });
    return data.data;
  },
  async disableMfa(token: string): Promise<void> {
    await api.post('/auth/mfa/disable', { token });
  },
};
